import { useEffect, useState } from "react";
import { toast } from "sonner";
import { DollarSign, Download, RotateCcw } from "lucide-react";
import { api } from "@/lib/api";
import { Card, Badge, Btn, EmptyState } from "../AdminUI";

const pColor = (s) => ({ Approved: "green", Paid: "green", Declined: "red", Failed: "red", Refunded: "amber", "Partially Refunded": "amber" }[s] || "gray");

const dl = async (url, name) => {
  const r = await api.get(url, { responseType: "blob" });
  const u = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  const a = document.createElement("a"); a.href = u; a.download = name; a.click(); URL.revokeObjectURL(u);
};

export default function Payments({ canRefund }) {
  const [pays, setPays] = useState([]);
  const load = () => api.get("/admin/payments").then((r) => setPays(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const refund = async (p) => {
    const amt = window.prompt(`Refund amount (max $${(p.amount - (p.refund_amount||0)).toFixed(2)}):`);
    if (!amt) return;
    const reason = window.prompt("Reason:") || "";
    try { await api.post(`/admin/payments/${p.id}/refund`, { amount: parseFloat(amt), reason }); toast.success("Refund recorded"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="space-y-6">
      <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">Payments</h1>
      <Card>
        {pays.length === 0 ? <EmptyState icon={DollarSign} title="No payments yet" hint="Payments recorded against invoices appear here." /> : (
          <div className="overflow-x-auto -m-1">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-400 text-xs uppercase border-b"><th className="py-2 px-2">Date</th><th className="px-2">Amount</th><th className="px-2">Method</th><th className="px-2">Details</th><th className="px-2">Status</th><th className="px-2 text-right">Actions</th></tr></thead>
              <tbody>{pays.map((p) => (
                <tr key={p.id} className="border-b border-gray-50 hover:bg-gray-50" data-testid={`payment-row-${p.id}`}>
                  <td className="py-3 px-2 text-gray-600">{p.payment_date}</td>
                  <td className="px-2 font-semibold">${p.amount?.toFixed(2)}{p.refund_amount ? <span className="text-amber-600 text-xs"> (-${p.refund_amount})</span> : ""}</td>
                  <td className="px-2 text-gray-600">{p.payment_method}</td>
                  <td className="px-2 text-gray-500">{p.masked_account || "—"}</td>
                  <td className="px-2"><Badge color={pColor(p.status)}>{p.status}</Badge></td>
                  <td className="px-2 text-right whitespace-nowrap">
                    {p.receipt_number && <button onClick={() => dl(`/admin/payments/${p.id}/receipt`, `${p.receipt_number}.pdf`)} className="text-[var(--action)] mr-3" title="Receipt" data-testid={`pay-receipt-${p.id}`}><Download className="w-4 h-4 inline" /></button>}
                    {canRefund && p.status !== "Refunded" && <button onClick={() => refund(p)} className="text-gray-400 hover:text-[var(--red)]" title="Refund" data-testid={`pay-refund-${p.id}`}><RotateCcw className="w-4 h-4 inline" /></button>}
                  </td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
